import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { reducers } from 'reducers';
import * as api from 'api';
import { rtkQueryErrorLogger } from 'api/errorHandle';

const apiModules = [
	api.mw?.address,
	api.mw?.addresses,
	api.mw?.admin?.area,
	api.mw?.admin?.child,
	api.mw?.admin?.domain,
	api.mw?.admin?.group,
	api.mw?.admin?.space,
	api.mw?.admin?.state,
	api.mw?.admin?.user,
	api.mw?.app,
	api.mw?.aiChat,
	api.mw?.appeal,
	api.mw?.appealWorkspace,
	api.mw?.appealLabel,
	api.mw?.auth,
	api.mw?.callHistory,
	api.mw?.customer,
	api.mw?.dashboard,
	api.mw?.email,
	api.mw?.file,
	api.mw?.form,
	api.mw?.geo,
	api.mw?.interaction,
	api.mw?.kb,
	api.mw?.knowledgeBaseCollections,
	api.mw?.knowledgeBaseThemes,
	api.mw?.internalNotifications,
	api.mw?.knowledgeBaseTemplate,
	api.mw?.notificationTemplate,
	api.mw?.operator,
	api.mw?.order?.task,
	api.mw?.order?.task?.bu,
	api.mw?.request,
	api.mw?.request?.filterExtended,
	api.mw?.search,
	api.mw?.space,
	api.mw?.user,
	api.mw?.person,
	api.mw?.personalCabinet,
	api.mw?.education,
	api.mw?.maps,

	api.semanticSearch,

	api.sn?.callEvent,
	api.sn?.dialog,
	api.sn?.phone,
	api.sn?.server,
];

const apiReducers = apiModules.reduce((acc, module) => {
	const apiSlice = module?.default;

	if (apiSlice?.reducerPath && apiSlice.reducer) {
		acc[apiSlice.reducerPath] = apiSlice.reducer;
	}

	return acc;
}, {});

const apiMiddlewares = [
	rtkQueryErrorLogger,
	...apiModules
		.map((module) => module?.default?.middleware),
].filter((middleware) => typeof middleware === 'function');

const store = configureStore({
	reducer: {
		...reducers,
		...apiReducers,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat([thunk, ...apiMiddlewares]),

	devTools: true,
});

export default store;
